import * as AvatarPrimitive from '@radix-ui/react-avatar';
import React from 'react';

import { FallbackStyled, ImageStyled, RootStyled } from './styles';

export type AvatarSize = 'small' | 'medium-small' | 'medium';

export type AvatarProps = Omit<React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Root>, 'children'> & {
  size?: AvatarSize;
  outlined?: boolean;
  image?: string;
  text?: string;
  alt?: string;
};

export const Avatar = React.forwardRef<React.ElementRef<typeof AvatarPrimitive.Root>, AvatarProps>(
  ({ size = 'medium', outlined, image, text = '', alt = '', className, ...props }, ref): JSX.Element => {
    return (
      <RootStyled ref={ref} $size={size} $outlined={outlined} className={className} {...props}>
        {image ? <ImageStyled src={image} alt={alt} /> : null}
        <FallbackStyled>{text}</FallbackStyled>
      </RootStyled>
    );
  },
);

Avatar.displayName = 'Avatar';

export { AvatarsGroup } from './styles';
